import { useEffect, useRef } from "react";

// Thin saffron scroll-progress bar pinned under the header — gives long-form
// reading a sense of place and momentum. Updates the bar width directly via a
// ref inside requestAnimationFrame so scrolling never triggers a React re-render
// (avoids per-frame re-renders that caused scroll jank/freezing on mobile).
export default function ReadingProgress() {
  const barRef = useRef(null);
  useEffect(() => {
    let ticking = false;
    const update = () => {
      ticking = false;
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      const pct = max > 0 ? Math.min(100, (h.scrollTop / max) * 100) : 0;
      if (barRef.current) barRef.current.style.width = `${pct}%`;
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => { window.removeEventListener("scroll", onScroll); window.removeEventListener("resize", onScroll); };
  }, []);
  return (
    <div className="fixed inset-x-0 top-0 z-40 h-[3px] bg-transparent" data-testid="reading-progress" aria-hidden>
      <div ref={barRef} className="h-full bg-[var(--saffron)] ease-out" style={{ width: "0%" }} />
    </div>
  );
}
